import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import posthog from 'posthog-js';
import { axiosInstance } from '../lib/axios';

export function useQuickplayStart() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['quickplay-start'],
        mutationFn: async ({ deferKickoff } = {}) => {
            const response = typeof deferKickoff === 'boolean'
                ? await axiosInstance.post('/quickplay/start', { deferKickoff })
                : await axiosInstance.post('/quickplay/start');
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['user-leagues'] });
        }
    });
}

export function useQuickplayKickoff() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['quickplay-kickoff'],
        mutationFn: async () => {
            const response = await axiosInstance.post('/quickplay/kickoff');
            return response.data;
        },
        onSuccess: async (data) => {
            posthog.capture('quickplay_first_sim_started', {
                match_id: data.matchId,
                league_id: data.leagueId
            });
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['match'] }),
                queryClient.invalidateQueries({ queryKey: ['league-fixtures'] }),
                queryClient.invalidateQueries({ queryKey: ['quickplay-state'] })
            ]);
        }
    });
}

export function useQuickplayRematch() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['quickplay-rematch'],
        mutationFn: async () => {
            const response = await axiosInstance.post('/quickplay/rematch');
            return response.data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['user-leagues'] }),
                queryClient.invalidateQueries({ queryKey: ['matches'] }),
                queryClient.invalidateQueries({ queryKey: ['league'] }),
                queryClient.invalidateQueries({ queryKey: ['league-fixtures'] })
            ]);
        }
    });
}

export function useQuickplayState(enabled = true) {
    return useQuery({
        queryKey: ['quickplay-state'],
        queryFn: async () => {
            const response = await axiosInstance.get('/quickplay/state');
            return response.data;
        },
        enabled,
        retry: false
    });
}
